import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type {
  PostitCreate,
  PostitListResponse,
  PostitRecord,
  PostitUpdate,
} from "@/types/operacoes/postits";
import { postitKeys } from "./keys";

export function usePostits(params?: { scope?: string }) {
  return useQuery({
    queryKey: postitKeys.list(params),
    queryFn: () =>
      api.get<PostitListResponse>("/postits", params as Record<string, string>),
    // Poll a cada 30 s para edições de outros usuários aparecerem automaticamente.
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}

export function useCreatePostit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: PostitCreate) =>
      api.post<PostitRecord>("/postits", data),
    onSuccess: () => qc.invalidateQueries({ queryKey: postitKeys.all }),
  });
}

export function useUpdatePostit(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: PostitUpdate) =>
      api.patch<PostitRecord>(`/postits/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: postitKeys.all }),
  });
}

export function useDeletePostit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/postits/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: postitKeys.all }),
  });
}
